var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    display: "block",
    className: "vkuiIcon vkuiIcon--28 vkuiIcon--w-28 vkuiIcon--h-28 vkuiIcon--help_circle_outline_28",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    style: {
      width: 28,
      height: 28
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28",
    id: "help_circle_outline_28"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 2c6.624 0 12 5.376 12 12s-5.376 12-12 12S2 20.624 2 14 7.376 2 14 2m0 2C8.48 4 4 8.48 4 14s4.48 10 10 10 10-4.48 10-10S19.52 4 14 4m0 14.1a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8m-.066-11.11c2.05 0 3.712 1.678 3.712 3.75 0 .825-.334 1.575-.863 2.11l-.835.862c-.497.509-.855.95-1.006 1.72q-.021.105-.03.31a.926.926 0 0 1-.925.883h-.01a.93.93 0 0 1-.928-.928v-.002q.002-.39.025-.512a3.8 3.8 0 0 1 1.018-1.94l1.15-1.181a1.871 1.871 0 0 0-1.308-3.197c-.649 0-1.222.34-1.554.854a4 4 0 0 0-.248.485.93.93 0 0 1-1.147.499l-.035-.012a.886.886 0 0 1-.534-1.175q.1-.242.19-.427c.638-1.297 1.838-2.099 3.328-2.099"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#help_circle_outline_28",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.fab7444bcca179e77e454709db3c69ca.svg";
export { ForwardRef as ReactComponent };